<template>
  <v-list dense>
    <v-subheader :style="destinationColor" class="pr-0">
      <span class="destination-title">{{destination.address}}</span><strong>&nbsp;[{{ destination.transport }}]&nbsp;</strong>
      <v-tooltip bottom v-if="destination.freezed">
        Разблокировать
        <template #activator="data">
          <v-btn v-on="data.on" icon flat
          class="red--text text--darken-2"
          @click="unfreeze"
          >
          <v-icon dark>lock</v-icon>
        </v-btn>
        </template>
      </v-tooltip>
      <v-tooltip bottom v-else>
        <b>Заблокировать</b><br />
        - Будут отключены все подписки,<br />
        <span v-if="destination.transport === 'email'">- Адрес нельзя будет использовать для востановления пароля и смс-команд,<br /></span>
        <span v-if="destination.transport === 'email'">- Адрес не будет учитываться при связывании аккаунтов.<br /></span>
        <b>Используйте в случае, если вы больше не владеете данным адресом.</b><br />
        Действие обратимо.
        <template #activator="data">
          <v-btn v-on="data.on" icon flat color="primary"
          class="grey--text"
          @click="freeze"
          >
          <v-icon>lock_open</v-icon>
        </v-btn>
        </template>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-subheader>
    <v-list dense v-if="!destination.freezed">
      <v-btn v-if="destination.transport === 'telegram'" href="https://t.me/SHKID_bot" target="_blank" :style="destinationColor" outline small>
        Перейти к боту
      </v-btn>
      <v-btn v-if="destination.transport === 'viber'" href="viber://pa?chatURI=shkid" target="_blank" :style="destinationColor" outline small>
        Перейти к боту
      </v-btn>
      <v-btn v-if="destination.transport === 'vk'" href="https://vk.me/shkid43" target="_blank" :style="destinationColor" outline small>
        Перейти к боту
      </v-btn>
      <v-subheader v-if="['telegram', 'viber', 'vk'].includes(destination.transport) && destination.params.dateto">
        Подписка активна до {{dateFormat(destination.params.dateto)}}
      </v-subheader>
      <v-subheader v-if="['telegram', 'viber', 'vk'].includes(destination.transport) && !destination.params.dateto">
        Подписка не активна
      </v-subheader>
      <v-subheader>уведомления ({{destination.transport}}):</v-subheader>
      <v-switch class="pl-3 mt-1"
      v-model="destination.subscriptions" value="pass"
      label="проходы через турникет" @change="update"
      ></v-switch>

      <v-switch class="pl-3 mt-1"
      v-model="destination.subscriptions" value="payment"
      label="пополнение счёта" @change="update"
      ></v-switch>

      <v-switch v-if="destination.transport !== 'sms'" class="pl-3 mt-1"
      v-model="destination.subscriptions" value="purchase"
      label="покупки в столовой" @change="update"
      ></v-switch>

      <v-switch v-if="destination.transport !== 'sms'" class="pl-3 mt-1"
      v-model="destination.subscriptions" value="news"
      label="публикация новостей" @change="update"
      ></v-switch>

      <!-- <v-switch v-if="false" class="pl-3 mt-1"
      v-model="destination.subscriptions" value="ride"
      label="проезд в транспорте" @change="update"
      ></v-switch>

      <v-switch v-if="false" class="pl-3 mt-1"
      v-model="destination.subscriptions" value="ridepayment"
      label="пополнение транспортного счета" @change="update"
      ></v-switch> -->

      <v-switch class="pl-3 mt-1" style="float:left"
      v-model="destination.subscriptions" value="lowbalance"
      :label="'низкий баланс ' + (destination.subscriptions.includes('lowbalance') ? `[ меньше ${destination.params.limit} руб. ]` : '')"
      @change="update"
      ></v-switch>
      <v-menu offset-y left  :close-on-content-click="false"
      v-if="destination.subscriptions.includes('lowbalance')">
        <v-btn icon slot="activator" class="mt-0">
          <v-icon color="primary lighten-2">settings</v-icon>
        </v-btn>
        <v-card v-if="destination.subscriptions.includes('lowbalance')" flat>
          <v-card-text>
            <h4>Отправляем сообщение, если на момент 17:00 баланс ниже значения:</h4>
            <v-slider class="pl-1"
            v-model="destination.params.limit" :label="destination.params.limit.toString()"
            min="1" max="300" ticks inverse-label
            @change="update"
            ></v-slider>
          </v-card-text>
        </v-card>
      </v-menu>
      <div style="clear:left">
      </div>
    </v-list>
    <br>
  </v-list>
</template>

<script>
const moment = require('moment')
export default {
  name: 'destination',
  data: () => ({
  }),
  props: [
    'destination'
  ],
  computed: {
    destinationColor () {
      if (!this.destination) return ''
      if (this.destination.freezed) return 'color: #888'
      if (this.destination.transport === 'email') return 'color: #F06764'
      if (this.destination.transport === 'sms') return 'color: #FFA726'
      if (this.destination.transport === 'telegram') return 'color: #42A5F5'
      if (this.destination.transport === 'viber') return 'color: #7B1FA2'
      if (this.destination.transport === 'vk') return 'color: #1565C0'
      return ''
    }
  },
  methods: {
    async update () {
      this.$emit('change')
    },
    async freeze () {
      await this.$store.dispatch('confirm', `Вы действительно хотите отключить адрес <b>${this.destination.address}</b>?<br />
      ${this.destination.transport === 'email' ? '- Адрес нельзя будет использовать для востановления пароля,<br />' : ''}
      ${this.destination.transport === 'email' ? '- Адрес не будет учитываться при связывании аккаунтов,<br />' : ''}
      - Будут отключены все подписки.<br />
      <b>Используйте в случае, если вы больше не владеете данным адресом или хотите отключить разом все подписки на данный адрес.</b><br />`)
      this.destination.freezed = moment().format('YYYY-MM-DD HH:mm:ss')
      this.update()
    },
    async unfreeze () {
      this.destination.freezed = null
      this.update()
    },
    dateFormat (date) {
      return moment(date).format('DD.MM.YYYY')
    }
  }
}
</script>

<style lang="css" scoped>
  .servicename {
    font-weight: 300;
    font-size: 15px;
    color: #888;
  }
  .destination-title {
    font-weight: 300;
    font-size: 24px;
  }
  @media screen and (max-width: 400px) {
    .destination-title {
      font-size: 17px !important;
    }
  }
</style>
